module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-plus-gray-053e325991e08ed8cab555048524ed4a.svg";